import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs: any;
import { SessionService } from '../../../shared/services/session.service';


@Component({
  selector: 'app-alfabetet-aa',
  templateUrl: './alfabetet-aa.component.html',
  styleUrls: ['./alfabetet-aa.component.scss']
})
export class AlfabetetAaComponent implements OnInit {

  public bloburl: string;
  private stage: any;

  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<AlfabetetAaComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;
  }


  ngOnInit() {
    this.shelf();
  }


  shelf() {

    var yr3_canvas: any = document.getElementById('yr3_canvas_alfabetet');
    yr3_canvas.width = 1785;
    yr3_canvas.height = 890;

    var stage = new createjs.Stage("yr3_canvas_alfabetet");
    this.stage = stage;

    var frame_img = new createjs.Bitmap(this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/shelf_img.png");
    frame_img.setTransform(395, 0, 0.83, 0.83);

    //30 containers for shelfs



    let alphabet_A: any = new createjs.Container();

    var capA = new Image();
    capA.crossOrigin = "Anonymous";
    capA.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_A.png";

    var cap_A = new createjs.Bitmap(capA);
    cap_A.setTransform(15, 98, 0.38, 0.38);

    var smallA = new Image();
    smallA.crossOrigin = "Anonymous";
    smallA.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_A.png";

    var small_A = new createjs.Bitmap(smallA);
    small_A.setTransform(70, 98, 0.38, 0.38);

    alphabet_A.addChild(cap_A, small_A);
    alphabet_A.setTransform(436, 54);


    let alphabet_B: any = new createjs.Container();

    var capB = new Image();
    capB.crossOrigin = "Anonymous";
    capB.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_B.png";

    var cap_B = new createjs.Bitmap(capB);
    cap_B.setTransform(13, 98, 0.38, 0.38);

    var smallB = new Image();
    smallB.crossOrigin = "Anonymous";
    smallB.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_B.png";

    var small_B = new createjs.Bitmap(smallB);
    small_B.setTransform(56, 98, 0.38, 0.38);


    alphabet_B.addChild(cap_B, small_B);
    alphabet_B.setTransform(588, 54);


    let alphabet_C: any = new createjs.Container();


    var capC = new Image();
    capC.crossOrigin = "Anonymous";
    capC.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_C.png";

    var smallC = new Image();
    smallC.crossOrigin = "Anonymous";
    smallC.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_C.png";

    var cap_C = new createjs.Bitmap(capC);
    cap_C.setTransform(22, 98, 0.38, 0.38);

    var small_C = new createjs.Bitmap(smallC);
    small_C.setTransform(65, 98, 0.38, 0.38);


    alphabet_C.addChild(cap_C, small_C);
    alphabet_C.setTransform(738, 54);


    let alphabet_D: any = new createjs.Container();


    var capD = new Image();
    capD.crossOrigin = "Anonymous";
    capD.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_D.png";

    var smallD = new Image();
    smallD.crossOrigin = "Anonymous";
    smallD.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_D.png";

    var cap_D = new createjs.Bitmap(capD);

    cap_D.setTransform(12, 98, 0.38, 0.38);
    var small_D = new createjs.Bitmap(smallD);
    small_D.setTransform(70, 98, 0.38, 0.38);


    alphabet_D.addChild(cap_D, small_D);
    alphabet_D.setTransform(890, 54);

    let alphabet_E: any = new createjs.Container();


    var capE = new Image();
    capE.crossOrigin = "Anonymous";
    capE.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_E.png";

    var smallE = new Image();
    smallE.crossOrigin = "Anonymous";
    smallE.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_E.png";

    var cap_E = new createjs.Bitmap(capE);
    cap_E.setTransform(20, 98, 0.38, 0.38);
    var small_E = new createjs.Bitmap(smallE);
    small_E.setTransform(59, 98, 0.38, 0.38);


    alphabet_E.addChild(cap_E, small_E);
    alphabet_E.setTransform(1042, 54);

    let alphabet_F: any = new createjs.Container();


    var capF = new Image();
    capF.crossOrigin = "Anonymous";
    capF.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_F.png";

    var smallF = new Image();
    smallF.crossOrigin = "Anonymous";
    smallF.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_F.png";

    var cap_F = new createjs.Bitmap(capF);
    cap_F.setTransform(16, 98, 0.38, 0.38);
    var small_F = new createjs.Bitmap(smallF);
    small_F.setTransform(58, 98, 0.38, 0.38);



    alphabet_F.addChild(cap_F, small_F);
    alphabet_F.setTransform(1192, 54);

    let alphabet_G: any = new createjs.Container();


    var capG = new Image();
    capG.crossOrigin = "Anonymous";
    capG.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_G.png";

    var smallG = new Image();
    smallG.crossOrigin = "Anonymous";
    smallG.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_G.png";

    var cap_G = new createjs.Bitmap(capG);
    cap_G.setTransform(19, 98, 0.38, 0.38);
    var small_G = new createjs.Bitmap(smallG);
    small_G.setTransform(66, 130, 0.38, 0.38);



    alphabet_G.addChild(cap_G, small_G);
    alphabet_G.setTransform(436, 204);

    let alphabet_H: any = new createjs.Container();


    var capH = new Image();
    capH.crossOrigin = "Anonymous";
    capH.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_H.png";

    var smallH = new Image();
    smallH.crossOrigin = "Anonymous";
    smallH.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_H.png";

    var cap_H = new createjs.Bitmap(capH);
    cap_H.setTransform(15, 98, 0.38, 0.38);
    var small_H = new createjs.Bitmap(smallH);
    small_H.setTransform(61, 98, 0.38, 0.38);



    alphabet_H.addChild(cap_H, small_H);
    alphabet_H.setTransform(588, 204);

    let alphabet_I: any = new createjs.Container();


    var capI = new Image();
    capI.crossOrigin = "Anonymous";
    capI.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_I.png";

    var smallI = new Image();
    smallI.crossOrigin = "Anonymous";
    smallI.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_I.png";

    var cap_I = new createjs.Bitmap(capI);
    cap_I.setTransform(30, 98, 0.38, 0.38);
    var small_I = new createjs.Bitmap(smallI);
    small_I.setTransform(45, 98, 0.38, 0.38);


    alphabet_I.addChild(cap_I, small_I);
    alphabet_I.setTransform(738, 204);

    let alphabet_J: any = new createjs.Container();


    var capJ = new Image();
    capJ.crossOrigin = "Anonymous";
    capJ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_J.png";

    var smallJ = new Image();
    smallJ.crossOrigin = "Anonymous";
    smallJ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_J.png";

    var cap_J = new createjs.Bitmap(capJ);
    cap_J.setTransform(26, 98, 0.38, 0.38);
    var small_J = new createjs.Bitmap(smallJ);
    small_J.setTransform(58, 120, 0.38, 0.38);



    alphabet_J.addChild(cap_J, small_J);
    alphabet_J.setTransform(890, 204);

    let alphabet_K: any = new createjs.Container();


    var capK = new Image();
    capK.crossOrigin = "Anonymous";
    capK.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_K.png";

    var smallK = new Image();
    smallK.crossOrigin = "Anonymous";
    smallK.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_K.png";

    var cap_K = new createjs.Bitmap(capK);
    cap_K.setTransform(15, 98, 0.38, 0.38);
    var small_K = new createjs.Bitmap(smallK);
    small_K.setTransform(58, 98, 0.38, 0.38);



    alphabet_K.addChild(cap_K, small_K);
    alphabet_K.setTransform(1042, 204);

    let alphabet_L: any = new createjs.Container();


    var capL = new Image();
    capL.crossOrigin = "Anonymous";
    capL.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_L.png";

    var smallL = new Image();
    smallL.crossOrigin = "Anonymous";
    smallL.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_L.png";

    var cap_L = new createjs.Bitmap(capL);
    cap_L.setTransform(31, 98, 0.38, 0.38);
    var small_L = new createjs.Bitmap(smallL);
    small_L.setTransform(61, 98, 0.38, 0.38);



    alphabet_L.addChild(cap_L, small_L);
    alphabet_L.setTransform(1192, 204);

    let alphabet_M: any = new createjs.Container();


    var capM = new Image();
    capM.crossOrigin = "Anonymous";
    capM.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_M.png";

    var smallM = new Image();
    smallM.crossOrigin = "Anonymous";
    smallM.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_M.png";

    var cap_M = new createjs.Bitmap(capM);
    cap_M.setTransform(9, 98, 0.38, 0.38);
    var small_M = new createjs.Bitmap(smallM);
    small_M.setTransform(74, 98, 0.38, 0.38);



    alphabet_M.addChild(cap_M, small_M);

    alphabet_M.setTransform(436, 354);

    let alphabet_N: any = new createjs.Container();


    var capN = new Image();
    capN.crossOrigin = "Anonymous";
    capN.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_N.png";

    var smallN = new Image();
    smallN.crossOrigin = "Anonymous";
    smallN.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_N.png";

    var cap_N = new createjs.Bitmap(capN);
    cap_N.setTransform(16, 98, 0.38, 0.38);
    var small_N = new createjs.Bitmap(smallN);
    small_N.setTransform(60, 98, 0.38, 0.38);




    alphabet_N.addChild(cap_N, small_N);
    alphabet_N.setTransform(588, 354);

    let alphabet_O: any = new createjs.Container();


    var capO = new Image();
    capO.crossOrigin = "Anonymous";
    capO.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_O.png";

    var smallO = new Image();
    smallO.crossOrigin = "Anonymous";
    smallO.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_O.png";

    var cap_O = new createjs.Bitmap(capO);
    cap_O.setTransform(14, 98, 0.38, 0.38);
    var small_O = new createjs.Bitmap(smallO);
    small_O.setTransform(70, 98, 0.38, 0.38);



    alphabet_O.addChild(cap_O, small_O);
    alphabet_O.setTransform(738, 354);

    let alphabet_P: any = new createjs.Container();


    var capP = new Image();
    capP.crossOrigin = "Anonymous";
    capP.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_P.png";

    var smallP = new Image();
    smallP.crossOrigin = "Anonymous";
    smallP.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_P.png";

    var cap_P = new createjs.Bitmap(capP);
    cap_P.setTransform(14, 98, 0.38, 0.38);
    var small_P = new createjs.Bitmap(smallP);
    small_P.setTransform(52, 130, 0.38, 0.38);


    alphabet_P.addChild(cap_P, small_P);
    alphabet_P.setTransform(890, 354);

    let alphabet_Q: any = new createjs.Container();


    var capQ = new Image();
    capQ.crossOrigin = "Anonymous";
    capQ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_Q.png";

    var smallQ = new Image();
    smallQ.crossOrigin = "Anonymous";
    smallQ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_Q.png";

    var cap_Q = new createjs.Bitmap(capQ);
    cap_Q.setTransform(16, 98, 0.38, 0.38);
    var small_Q = new createjs.Bitmap(smallQ);
    small_Q.setTransform(73, 130, 0.38, 0.38);



    alphabet_Q.addChild(cap_Q, small_Q);
    alphabet_Q.setTransform(1042, 354);

    let alphabet_R: any = new createjs.Container();


    var capR = new Image();
    capR.crossOrigin = "Anonymous";
    capR.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_R.png";

    var smallR = new Image();
    smallR.crossOrigin = "Anonymous";
    smallR.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_R.png";

    var cap_R = new createjs.Bitmap(capR);
    cap_R.setTransform(23, 98, 0.38, 0.38);
    var small_R = new createjs.Bitmap(smallR);
    small_R.setTransform(56, 98, 0.38, 0.38);




    alphabet_R.addChild(cap_R, small_R);
    alphabet_R.setTransform(1192, 354);

    let alphabet_S: any = new createjs.Container();


    var capS = new Image();
    capS.crossOrigin = "Anonymous";
    capS.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_S.png";

    var smallS = new Image();
    smallS.crossOrigin = "Anonymous";
    smallS.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_S.png";

    var cap_S = new createjs.Bitmap(capS);
    cap_S.setTransform(22, 98, 0.38, 0.38);
    var small_S = new createjs.Bitmap(smallS);
    small_S.setTransform(57, 98, 0.38, 0.38);



    alphabet_S.addChild(cap_S, small_S);

    alphabet_S.setTransform(436, 504);

    let alphabet_T: any = new createjs.Container();


    var capT = new Image();
    capT.crossOrigin = "Anonymous";
    capT.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_T.png";

    var smallT = new Image();
    smallT.crossOrigin = "Anonymous";
    smallT.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_T.png";

    var cap_T = new createjs.Bitmap(capT);
    cap_T.setTransform(20, 98, 0.38, 0.38);
    var small_T = new createjs.Bitmap(smallT);
    small_T.setTransform(61, 98, 0.38, 0.38);




    alphabet_T.addChild(cap_T, small_T);
    alphabet_T.setTransform(588, 504);


    let alphabet_U: any = new createjs.Container();


    var capU = new Image();
    capU.crossOrigin = "Anonymous";
    capU.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_U.png";

    var smallU = new Image();
    smallU.crossOrigin = "Anonymous";
    smallU.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_U.png";

    var cap_U = new createjs.Bitmap(capU);
    cap_U.setTransform(18, 98, 0.38, 0.38);
    var small_U = new createjs.Bitmap(smallU);
    small_U.setTransform(63, 98, 0.38, 0.38);




    alphabet_U.addChild(cap_U, small_U);
    alphabet_U.setTransform(738, 504);



    let alphabet_V: any = new createjs.Container();


    var capV = new Image();
    capV.crossOrigin = "Anonymous";
    capV.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_V.png";

    var smallV = new Image();
    smallV.crossOrigin = "Anonymous";
    smallV.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_V.png";

    var cap_V = new createjs.Bitmap(capV);
    cap_V.setTransform(17, 98, 0.38, 0.38);
    var small_V = new createjs.Bitmap(smallV);
    small_V.setTransform(65, 98, 0.38, 0.38);




    alphabet_V.addChild(cap_V, small_V);
    alphabet_V.setTransform(890, 504);



    let alphabet_W: any = new createjs.Container();


    var capW = new Image();
    capW.crossOrigin = "Anonymous";
    capW.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_W.png";

    var smallW = new Image();
    smallW.crossOrigin = "Anonymous";
    smallW.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_W.png";

    var cap_W = new createjs.Bitmap(capW);
    cap_W.setTransform(11, 98, 0.38, 0.38);
    var small_W = new createjs.Bitmap(smallW);
    small_W.setTransform(78, 98, 0.38, 0.38);




    alphabet_W.addChild(cap_W, small_W);
    alphabet_W.setTransform(1042, 504);

    let alphabet_X: any = new createjs.Container();


    var capX = new Image();
    capX.crossOrigin = "Anonymous";
    capX.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_X.png";

    var smallX = new Image();
    smallX.crossOrigin = "Anonymous";
    smallX.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_X.png";

    var cap_X = new createjs.Bitmap(capX);
    cap_X.setTransform(17, 98, 0.38, 0.38);
    var small_X = new createjs.Bitmap(smallX);
    small_X.setTransform(64, 98, 0.38, 0.38);



    alphabet_X.addChild(cap_X, small_X);
    alphabet_X.setTransform(1192, 504);

    let alphabet_Y: any = new createjs.Container();


    var capY = new Image();
    capY.crossOrigin = "Anonymous";
    capY.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_Y.png";

    var smallY = new Image();
    smallY.crossOrigin = "Anonymous";
    smallY.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_Y.png";

    var cap_Y = new createjs.Bitmap(capY);
    cap_Y.setTransform(12, 98, 0.38, 0.38);
    var small_Y = new createjs.Bitmap(smallY);
    small_Y.setTransform(59, 130, 0.38, 0.38);




    alphabet_Y.addChild(cap_Y, small_Y);
    alphabet_Y.setTransform(436, 654);

    let alphabet_Z: any = new createjs.Container();


    var capZ = new Image();
    capZ.crossOrigin = "Anonymous";
    capZ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_Z.png";

    var smallZ = new Image();
    smallZ.crossOrigin = "Anonymous";
    smallZ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_Z.png";

    var cap_Z = new createjs.Bitmap(capZ);
    cap_Z.setTransform(19, 98, 0.38, 0.38);
    var small_Z = new createjs.Bitmap(smallZ);
    small_Z.setTransform(64, 98, 0.38, 0.38);




    alphabet_Z.addChild(cap_Z, small_Z);
    alphabet_Z.setTransform(588, 654);

    let alphabet_Å: any = new createjs.Container();


    var capÅ = new Image();
    capÅ.crossOrigin = "Anonymous";
    capÅ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_Å.png";

    var smallÅ = new Image();
    smallÅ.crossOrigin = "Anonymous";
    smallÅ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_Å.png";

    var cap_Å = new createjs.Bitmap(capÅ);
    cap_Å.setTransform(15, 82, 0.40, 0.40);
    var small_Å = new createjs.Bitmap(smallÅ);
    small_Å.setTransform(71, 98, 0.38, 0.38);


    alphabet_Å.addChild(cap_Å, small_Å);
    alphabet_Å.setTransform(738, 654);

    let alphabet_Ä: any = new createjs.Container();


    var capÄ = new Image();
    capÄ.crossOrigin = "Anonymous";
    capÄ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_Ä.png";

    var smallÄ = new Image();
    smallÄ.crossOrigin = "Anonymous";
    smallÄ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_Ä.png";

    var cap_Ä = new createjs.Bitmap(capÄ);
    cap_Ä.setTransform(16, 87, 0.38, 0.38);
    var small_Ä = new createjs.Bitmap(smallÄ);
    small_Ä.setTransform(72, 98, 0.38, 0.38);




    alphabet_Ä.addChild(cap_Ä, small_Ä);
    alphabet_Ä.setTransform(890, 654);

    let alphabet_Ö: any = new createjs.Container();


    var capÖ = new Image();
    capÖ.crossOrigin = "Anonymous";
    capÖ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Caps_Ö.png";

    var smallÖ = new Image();
    smallÖ.crossOrigin = "Anonymous";
    smallÖ.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/Shelf_Small_Ö.png";

    var cap_Ö = new createjs.Bitmap(capÖ);
    cap_Ö.setTransform(14, 87, 0.38, 0.38);
    var small_Ö = new createjs.Bitmap(smallÖ);
    small_Ö.setTransform(73, 98, 0.38, 0.38);




    alphabet_Ö.addChild(cap_Ö, small_Ö);
    alphabet_Ö.setTransform(1042, 654);

    let alphabet_emp: any = new createjs.Container();

    alphabet_emp.setTransform(1192, 654);


    var drake = new Image();
    drake.crossOrigin = "Anonymous";
    drake.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Version2/Images/drake_1.png";

    var img_30 = new createjs.Bitmap(drake);
    img_30.setTransform(25, 130);


    alphabet_emp.addChild(img_30);




    stage.addChild(frame_img, alphabet_A, alphabet_B, alphabet_C, alphabet_D, alphabet_E, alphabet_F, alphabet_G, alphabet_H, alphabet_I,
      alphabet_J, alphabet_K, alphabet_L, alphabet_M, alphabet_N, alphabet_O, alphabet_P, alphabet_Q, alphabet_R, alphabet_S, alphabet_T,
      alphabet_U, alphabet_V, alphabet_W, alphabet_X, alphabet_Y, alphabet_Z, alphabet_Å, alphabet_Ä, alphabet_Ö, alphabet_emp);




    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }

  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');    
  }
}

